import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import * as S from './styled';

const Checkbox = (props) => {
  const {
    isChecked,
    isDisabled,
    isIndeterminate,
    defaultChecked,
    defaultIndeterminate,
    label,
    onChange,
    components,
    ...inputProps
  } = props;
  const checkRef = useRef();
  const isControlled = isChecked !== undefined;

  useEffect(() => {
    if (!isControlled && defaultChecked !== undefined) {
      checkRef.current.checked = defaultChecked;
    }

    if (isIndeterminate !== undefined) {
      checkRef.current.indeterminate = isIndeterminate;
    } else if (defaultIndeterminate !== undefined) {
      checkRef.current.indeterminate = defaultIndeterminate;
    }
  }, [isChecked, isIndeterminate]);

  const CheckboxInput = (
    <>
      <S.Checkbox
        type="checkbox"
        ref={checkRef}
        checked={isChecked}
        disabled={isDisabled}
        style={{
          cursor: 'pointer',
        }}
        onChange={(ev) => {
          if (onChange && !isDisabled && !components.CheckboxItem) {
            onChange(ev);
          }
        }}
        {...inputProps}
      />
      {label !== null && <S.CheckboxLabel>{label}</S.CheckboxLabel>}
    </>
  );

  if (components.CheckboxItem === null) {
    return CheckboxInput;
  }

  return (
    <components.CheckboxItem
      onClick={(ev) => {
        if (onChange && !isDisabled) {
          onChange(ev);
        }
      }}
    >
      {CheckboxInput}
    </components.CheckboxItem>
  );
};

Checkbox.propTypes = {
  /** Set if the checkbox is checked. */
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  /** Set if the checkbox is indeterminate. */
  isIndeterminate: PropTypes.bool,
  /** Set if the checkbox is checked by default. */
  defaultChecked: PropTypes.bool,
  /** Set if the checkbox is indeterminate by default. */
  defaultIndeterminate: PropTypes.bool,
  /** Handler to be called on change. */
  onChange: PropTypes.func,
  /** Checkbox label. */
  label: PropTypes.string,
  components: PropTypes.object,
};

Checkbox.defaultProps = {
  label: null,
  isDisabled: false,
  components: {
    CheckboxItem: S.CheckboxItem,
  },
};

export default Checkbox;
